/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Delete_Event_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete the selected event?" |
*
* @param {Shortcut_Keys_Delete_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_delete_event_text = /** @type {((inputs?: Shortcut_Keys_Delete_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Delete_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voulez-vous vraiment supprimer l'evenement selectionne ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie das ausgewählte Ereignis wirklich löschen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sei sicuro di voler eliminare l'evento selezionato?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены, что хотите удалить выбранное событие?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Está seguro de que desea eliminar el evento seleccionado?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您确定要删除所选事件吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを削除してもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई चयनित इवेंट को हटाना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza de que deseja excluir o evento selecionado?")
	return /** @type {LocalizedString} */ ("Are you sure you want to delete the selected event?")
});